import { call, put, takeLatest } from 'redux-saga/effects';

import * as sagaCommon from '../sagasCommon';

import { GENERATE_MATRIX_CHILDREN, CREATE_GENERATED_MATRIX_ITEMS } from '../../constants/constant_saga_types';
import { SET_MATRIX_CHILDREN } from '../../constants/constant_action_types';
import * as apiMatrixChildren from '../../services/item/apiMatrixChildren';


export function* generateMatrixChildrenSaga(feathersApp) {
  yield takeLatest(GENERATE_MATRIX_CHILDREN, callGenerateMatrixChildren, feathersApp);
}

function* callGenerateMatrixChildren(feathersApp, action) {
  try {
    const { id, currency_id } = action;
    if (!id) return;

    yield sagaCommon.showProgressDataById();
    const matrixItem = yield call(apiMatrixChildren.getMatrixItem, feathersApp, { id, currency_id });
    yield put({ type: SET_MATRIX_CHILDREN, data: matrixItem });
    yield sagaCommon.doneDataById();
  } catch (e) {
    yield sagaCommon.showErrorDataById(e);
  }
}





export function* createGeneratedMatrixItemsSaga(feathersApp) {
  yield takeLatest(CREATE_GENERATED_MATRIX_ITEMS, callCreateGeneratedMatrixItems, feathersApp);
}

function* callCreateGeneratedMatrixItems(feathersApp, action) {
  try {
    yield sagaCommon.showProgressSaveRecord();
    const { data } = action;
    const { id } = data;

    const matrix_children = data.matrix_children.filter( matrixChild => {
      return matrixChild.toprocess;
    });

    const generateParams = {
      ...data,
      parent_item_id: id,
      matrix_children,
    };

    delete generateParams.id;

    const matrixDetailList = yield call( apiMatrixChildren.generateMatrixItem, feathersApp, generateParams);
    let numberOfItems = matrixDetailList.total_processed;
    yield put({ type: GENERATE_MATRIX_CHILDREN, id });
    yield sagaCommon.doneSaveRecord(null, numberOfItems + ' matrix children were processed');
  } catch (error) {
    yield sagaCommon.showErrorSaveRecord(error);
  }
}